import { memo } from "react";
import { AxisBottom } from "@visx/axis";
import { format } from "d3";
import type { ScaleLinear } from "d3-scale";
import { chartMargin as defaultChartMargin, AxisGElement } from "./styles";

interface XAxisYearProps {
  scale: ScaleLinear<number, number>;
  containerSize: { width: number; height: number };
  chartMargin?: { left: number; right: number; top: number; bottom: number };
}

const XAxisYear = ({ scale, containerSize, chartMargin = defaultChartMargin }: XAxisYearProps) => {
  const [scaleMin, scaleMax] = scale.domain();
  const tickDifferenceLimit = 16;
  const numTicks =
    scaleMax - scaleMin > tickDifferenceLimit
      ? undefined
      : scaleMax - scaleMin;

  return (
    <AxisGElement
      transform={`translate(0, ${containerSize.height - chartMargin.bottom})`}
    >
      <AxisBottom
        scale={scale}
        numTicks={numTicks}
        tickFormat={(value) => format(".0f")(value as number)}
        hideAxisLine
        hideTicks
      />
    </AxisGElement>
  );
};

export default memo(XAxisYear);
